//@flow
import React from 'react';
import { connect } from 'react-redux';
// Helpers
import {
  priceConverter,
  getCashbackExpirationInfo,
  ClockIcon,
} from '../../common';
// Styles
import './BigClubIndicator.css';
// Types
import type { Connector } from 'react-redux';
import type { FeaturesConfig } from '../../preferences/types';
// Selectors
import { featuresConfigSelector } from '../../preferences/selectors';

type Props = {
  bigClubInformation: {
    totalAvailableBigclubCredit: number,
    bigclubCreditExpiresAt?: string,
    bigclubCreditExpired?: boolean,
  },
  featuresConfig: FeaturesConfig,
};

const BigClubIndicator = ({ bigClubInformation, featuresConfig }: Props) => {
  const totalAvailableBigclubCredit =
    bigClubInformation?.totalAvailableBigclubCredit
      ? priceConverter(bigClubInformation?.totalAvailableBigclubCredit)
      : priceConverter(0);

  const { showExpiration, expirationTextColor, expirationText } =
    getCashbackExpirationInfo(
      bigClubInformation?.bigclubCreditExpiresAt,
      bigClubInformation?.bigclubCreditExpired,
    );

  let titleText = `Você possui ${totalAvailableBigclubCredit} de saldo BigClub.`;
  if (showExpiration) {
    titleText += ` Atenção: Parte do saldo expira ${expirationText}!`;
  }

  if (!featuresConfig?.bigclubFeature) {
    return null;
  }

  return (
    <div className="big-club-indicator-main" title={titleText}>
      <div className="big-club-indicator-header">
        <span className="big-club-indicator-description">Saldo BigClub</span>
        {showExpiration && (
          <ClockIcon size={14} color={expirationTextColor} />
        )}
      </div>
      <div className="big-club-indicator-balance">
        <span className={`big-club-indicator-balance-value`}>
          {totalAvailableBigclubCredit}
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    featuresConfig: featuresConfigSelector(state),
  };
};

const connector: Connector<{}, Props> = connect(mapStateToProps);
export default connector(BigClubIndicator);
